const categories = [
  { name: '动作大片', icon: 'ri-sword-line', count: '2,860部', color: 'bg-accent-100 text-accent-700' },
  { name: '喜剧电影', icon: 'ri-emotion-happy-line', count: '1,950部', color: 'bg-primary-100 text-primary-700' },
  { name: '悬疑推理', icon: 'ri-search-eye-line', count: '1,420部', color: 'bg-secondary-100 text-secondary-700' },
  { name: '爱情文艺', icon: 'ri-heart-line', count: '1,680部', color: 'bg-accent-100 text-accent-700' },
  { name: '科幻巨制', icon: 'ri-rocket-line', count: '980部', color: 'bg-primary-100 text-primary-700' },
  { name: '恐怖惊悚', icon: 'ri-ghost-line', count: '860部', color: 'bg-secondary-100 text-secondary-700' },
  { name: '国产剧集', icon: 'ri-tv-line', count: '3,240部', color: 'bg-accent-100 text-accent-700' },
  { name: '热门综艺', icon: 'ri-mic-line', count: '1,560期', color: 'bg-primary-100 text-primary-700' },
  { name: '动漫番剧', icon: 'ri-ghost-smile-line', count: '2,100部', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">影视分类</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">覆盖全品类影视资源，精准分类快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group flex flex-col items-center p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer no-underline"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${cat.color} mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1 whitespace-nowrap">{cat.name}</h3>
              <span className="text-xs text-foreground-400">{cat.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}